var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.57191C9.17175 4.57191 3.63636 10.1073 3.63636 16.9355H0C0 8.09899 7.16344 0.935547 16 0.935547C24.8366 0.935547 32 8.09899 32 16.9355H28.3636C28.3636 10.1073 22.8282 4.57191 16 4.57191ZM16.0005 8.93793C15.6506 8.93793 15.3064 8.95932 14.9692 9.0007L14.7035 6.83512C15.1286 6.78295 15.5616 6.75611 16.0005 6.75611C16.4394 6.75611 16.8723 6.78295 17.2975 6.83512L17.0317 9.0007C16.6946 8.95932 16.3504 8.93793 16.0005 8.93793ZM20.8249 10.4824C20.276 10.0856 19.6716 9.75458 19.0244 9.50211L19.8173 7.46948C20.6375 7.78944 21.405 8.2095 22.1032 8.71428L20.8249 10.4824ZM12.9766 9.50211C12.3294 9.75458 11.7249 10.0856 11.176 10.4824L9.89776 8.71428C10.596 8.2095 11.3634 7.78944 12.1836 7.46948L12.9766 9.50211ZM23.3776 13.6147C23.1032 12.9924 22.7441 12.4107 22.3131 11.8831L24.0028 10.5028C24.5553 11.1791 25.0185 11.9284 25.3739 12.7343L23.3776 13.6147ZM9.68781 11.8832C9.25681 12.4107 8.89776 12.9924 8.62333 13.6147L6.62702 12.7343C6.98244 11.9284 7.44567 11.1791 7.99815 10.5028L9.68781 11.8832ZM17.0516 16.7413L20.0138 12.22L15.4925 15.1822C15.062 15.6127 15.062 16.3108 15.4925 16.7413C15.923 17.1718 16.621 17.1718 17.0516 16.7413Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.cded4a3edf6996098eb5b53965585fe2.svg";
export { ForwardRef as ReactComponent };